export default __webpack_public_path__ + "media/images/services-02-350x220-60c7d58c02f7372859f1acca317cab34.jpg";